export const promptDescriptionClasses = 'space-y-3';
export const promptFormClasses = 'flex items-end gap-2';
export const promptFieldClasses = 'flex-1';
export const promptErrorClasses = 'text-destructive text-sm';
export const confirmRowClasses = 'flex items-center gap-2';
export const confirmTextClasses = 'flex-1';
export const confirmNumberClasses = 'font-medium';
